import React from "react";

const MobileFeatures = () => {
  return (
    <div>
      <div
        id="carouselExampleControls"
        className="carousel slide d-lg-none w-100"
        data-bs-ride="carousel"
      >
        <div className="carousel-inner">
          <div className="carousel-item active">
            <div className="landing-feature-img-wrap">
              <img
                src="https://tbmcerts.s3.us-west-1.amazonaws.com/tbmcert-features-3.jpg"
                className="d-block w-100 mw-100"
                alt="Imagen 1"
                style={{ borderRadius: "25px" }}
              />
              <div className="landing-feature-img-overlay" aria-hidden="true" style={{ borderRadius: "25px" }} />
            </div>
            <div className="carousel-caption text-start">
              <h5 className="h3 display-3">Emprende tu propio negocio</h5>
            </div>
          </div>
          <div className="carousel-item">
            <div className="landing-feature-img-wrap">
              <img
                src="https://tbmcerts.s3.us-west-1.amazonaws.com/tbmcert-features-2.jpg"
                className="d-block w-100 mw-100"
                alt="Imagen 2"
                style={{ borderRadius: "25px" }}
              />
              <div className="landing-feature-img-overlay" aria-hidden="true" style={{ borderRadius: "25px" }} />
            </div>
            <div className="carousel-caption text-start">
              <h5 className="h3 display-3">Amplía tus conocimientos</h5>
            </div>
          </div>
          <div className="carousel-item">
            <div className="landing-feature-img-wrap">
              <img
                src="https://tbmcerts.s3.us-west-1.amazonaws.com/tbmcert-features-1.jpg"
                className="d-block w-100 mw-100"
                alt="Imagen 3"
                style={{ borderRadius: "25px" }}
              />
              <div className="landing-feature-img-overlay" aria-hidden="true" style={{ borderRadius: "25px" }} />
            </div>
            <div className="carousel-caption text-start">
              <h5 className="h3 display-3">Mejora tu técnica</h5>
            </div>
          </div>
        </div>
      </div>
      <div className="text-center py-3">
        <button
          className="btn btn-light btn-arrow border me-2"
          type="button"
          data-bs-target="#carouselExampleControls"
          data-bs-slide="prev"
        >
          <i className="fa fa-chevron-left" />
        </button>
        <button
          className="btn btn-light btn-arrow border"
          type="button"
          data-bs-target="#carouselExampleControls"
          data-bs-slide="next"
        >
          <i className="fa fa-chevron-right" />
        </button>
      </div>
    </div>
  );
};

export default MobileFeatures;
